'use strict';

const assert = require('assert');
const { v4: uuidv4 } = require('uuid');

const ALL_ITEM_CLASSES = [
  require('./equipment/weapon/Sword'),
  require('./equipment/weapon/Dagger'),
  require('./equipment/weapon/Hammer'),
  require('./equipment/weapon/Staff'),
  require('./equipment/off_hand/Bow'),
  require('./equipment/off_hand/Shield'),
  require('./equipment/off_hand/Book'),
  require('./equipment/off_hand/Trinket'),
  require('./equipment/helmet/LightHelmet'),
  require('./equipment/helmet/MedHelmet'),
  require('./equipment/helmet/HeavyHelmet'),
  require('./equipment/torsoe/LightTorsoe'),
  require('./equipment/torsoe/MedTorsoe'),
  require('./equipment/torsoe/HeavyTorsoe'),
  require('./equipment/boots/LightBoots'),
  require('./equipment/boots/MedBoots'),
  require('./equipment/boots/HeavyBoots'),
  require('./equipment/Ring'),
  require('./item_container/Bag'),
];

const PREFIXES = [
  require('./mods/prefixes/Blessed'),
  require('./mods/prefixes/Clumsy'),
  require('./mods/prefixes/Coarse'),
  require('./mods/prefixes/Crude'),
  require('./mods/prefixes/Cursed'),
  require('./mods/prefixes/Dull'),
  require('./mods/prefixes/Elegant'),
  require('./mods/prefixes/Emblazoned'),
  require('./mods/prefixes/Fine'),
  require('./mods/prefixes/Glorious'),
  require('./mods/prefixes/Glowing'),
  require('./mods/prefixes/Heavy'),
  require('./mods/prefixes/Lavish'),
  require('./mods/prefixes/Light'),
  require('./mods/prefixes/Lucky'),
  require('./mods/prefixes/Magical'),
  require('./mods/prefixes/Majestic'),
  require('./mods/prefixes/Modest'),
  require('./mods/prefixes/Ornate'),
  require('./mods/prefixes/Rotting'),
  require('./mods/prefixes/Runed'),
  require('./mods/prefixes/Scuffed'),
  require('./mods/prefixes/Shining'),
  require('./mods/prefixes/Sleek'),
  require('./mods/prefixes/Unlucky'),
  require('./mods/prefixes/Ulrich'),
  require('./mods/prefixes/Garland'),
  require('./mods/prefixes/Vetronius'),
  require('./mods/prefixes/Sindri'),
  require('./mods/prefixes/Cousity'),
];

const WEAPON_PREFIXES = [
  require('./mods/prefixes/weapon/Barbaric'),
  require('./mods/prefixes/weapon/Barbed'),
  require('./mods/prefixes/weapon/Brutal'),
  require('./mods/prefixes/weapon/Fragile'),
  require('./mods/prefixes/weapon/Gladiator'),
  require('./mods/prefixes/weapon/Hefty'),
  require('./mods/prefixes/weapon/Masterwork'),
  require('./mods/prefixes/weapon/Murderous'),
  require('./mods/prefixes/weapon/Swift'),
  require('./mods/prefixes/weapon/Unbalanced'),
  require('./mods/prefixes/weapon/Vampiric'),
  require('./mods/prefixes/weapon/Venomous'),
  require('./mods/prefixes/weapon/Weeping'),
  require('./mods/prefixes/weapon/WellBalanced'),
];

const ARMOR_PREFIXES = [
  require('./mods/prefixes/armor/Fitted'),
  require('./mods/prefixes/armor/Padded'),
  require('./mods/prefixes/armor/Patched'),
  require('./mods/prefixes/armor/Ragged'),
  require('./mods/prefixes/armor/Stinking'),
  require('./mods/prefixes/armor/Thin'),
  require('./mods/prefixes/armor/Warm'),
  require('./mods/prefixes/armor/Scrubbed'),
];

const SUFFIXES = [
  require('./mods/suffixes/Anger'),
  require('./mods/suffixes/Balance'),
  require('./mods/suffixes/Bear'),
  require('./mods/suffixes/Boar'),
  require('./mods/suffixes/Chaos'),
  require('./mods/suffixes/Cunning'),
  require('./mods/suffixes/Defense'),
  require('./mods/suffixes/Doom'),
  require('./mods/suffixes/Dragon'),
  require('./mods/suffixes/Eagle'),
  require('./mods/suffixes/Fawn'),
  require('./mods/suffixes/Health'),
  require('./mods/suffixes/Ignorance'),
  require('./mods/suffixes/Leadership'),
  require('./mods/suffixes/Life'),
  require('./mods/suffixes/Madness'),
  require('./mods/suffixes/Might'),
  require('./mods/suffixes/Mountain'),
  require('./mods/suffixes/Order'),
  require('./mods/suffixes/Ox'),
  require('./mods/suffixes/Power'),
  require('./mods/suffixes/Protection'),
  require('./mods/suffixes/Resilience'),
  require('./mods/suffixes/Scourge'),
  require('./mods/suffixes/Sea'),
  require('./mods/suffixes/Sky'),
  require('./mods/suffixes/Sloth'),
  require('./mods/suffixes/Snake'),
  require('./mods/suffixes/Speed'),
  require('./mods/suffixes/Stupidity'),
  require('./mods/suffixes/Tiger'),
  require('./mods/suffixes/Travelling'),
  require('./mods/suffixes/Tree'),
  require('./mods/suffixes/Unicorn'),
  require('./mods/suffixes/Vulgar'),
  require('./mods/suffixes/Weakness'),
  require('./mods/suffixes/Whale'),
  require('./mods/suffixes/Wonder'),
  require('./mods/suffixes/Rejuvenation'),
  require('./mods/suffixes/Poise'),
  require('./mods/suffixes/Focus'),
  require('./mods/suffixes/Novice'),
  require('./mods/suffixes/Fortress'),
  require('./mods/suffixes/Lunatic'),
  require('./mods/suffixes/Dove'),
];

const WEAPON_SUFFIXES = [
  require('./mods/suffixes/weapon/Destruction'),
  require('./mods/suffixes/weapon/Fire'),
  require('./mods/suffixes/weapon/Ice'),
  require('./mods/suffixes/weapon/Penetration'),
  require('./mods/suffixes/weapon/Thunder'),
  require('./mods/suffixes/weapon/Terror'),
];

const CHAOS_SUFFIX_TAGS = [
  'anger',
  'boar',
  'chaos',
  'cunning',
  'destruction',
  'dragon',
  'fawn',
  'fire',
  'madness',
  'power',
  'scourge',
  'speed',
  'stupidity',
  'terror',
  'lunatic',
];

const BALANCE_SUFFIX_TAGS = [
  'balance',
  'bear',
  'life',
  'might',
  'penetration',
  'sky',
  'sloth',
  'snake',
  'tiger',
  'thunder',
  'travelling',
  'poise',
  'focus',
];

const ORDER_SUFFIX_TAGS = [
  'defense',
  'doom',
  'eagle',
  'ice',
  'ignorance',
  'leadership',
  'mountain',
  'order',
  'ox',
  'protection',
  'resilience',
  'tree',
  'rejuvenation',
  'novice',
  'fortress',
  'dove',
];

var lastItem = {
  slot: null,
  type: null,
};

const addAffixMods = (item, affix) => {
  item.learning = (item.learning ? item.learning : 0) + (affix.learning ? affix.learning : 0);
  item.perception =
    (item.perception ? item.perception : 0) + (affix.perception ? affix.perception : 0);
  item.mana = (item.mana ? item.mana : 0) + (affix.mana ? affix.mana : 0);
  item.toughness = (item.toughness ? item.toughness : 0) + (affix.toughness ? affix.toughness : 0);
  item.strength = (item.strength ? item.strength : 0) + (affix.strength ? affix.strength : 0);
  item.willpower = (item.willpower ? item.willpower : 0) + (affix.willpower ? affix.willpower : 0);
  item.dexterity = (item.dexterity ? item.dexterity : 0) + (affix.dexterity ? affix.dexterity : 0);

  item.damageMod = (item.damageMod ? item.damageMod : 0) + (affix.damageMod ? affix.damageMod : 0);
  item.magicDamageMod =
    (item.magicDamageMod ? item.magicDamageMod : 0) +
    (affix.magicDamageMod ? affix.magicDamageMod : 0);
  item.physDamageMod =
    (item.physDamageMod ? item.physDamageMod : 0) + (affix.physDamageMod ? affix.physDamageMod : 0);
  item.meleeDamageMod =
    (item.meleeDamageMod ? item.meleeDamageMod : 0) +
    (affix.meleeDamageMod ? affix.meleeDamageMod : 0);
  item.bowDamageMod =
    (item.bowDamageMod ? item.bowDamageMod : 0) + (affix.bowDamageMod ? affix.bowDamageMod : 0);

  item.armorClass =
    (item.armorClass ? item.armorClass : 0) + (affix.armorClass ? affix.armorClass : 0);
  item.dodgeChance =
    (item.dodgeChance ? item.dodgeChance : 0) + (affix.dodgeChance ? affix.dodgeChance : 0);
  item.regeneration =
    (item.regeneration ? item.regeneration : 0) + (affix.regeneration ? affix.regeneration : 0);
  item.speed = (item.speed ? item.speed : 0) + (affix.speed ? affix.speed : 0);
  item.magicalGravity =
    (item.magicalGravity ? item.magicalGravity : 0) +
    (affix.magicalGravity ? affix.magicalGravity : 0);
  item.physicalResil =
    (item.physicalResil ? item.physicalResil : 0) + (affix.physicalResil ? affix.physicalResil : 0);
  item.mentalResil =
    (item.mentalResil ? item.mentalResil : 0) + (affix.mentalResil ? affix.mentalResil : 0);

  item.xp_bonus = (item.xp_bonus ? item.xp_bonus : 0) + (affix.xp_bonus ? affix.xp_bonus : 0);

  // set only when non-zero, so items generated before the field existed stay shape-compatible
  if (affix.loot_bonus) {
    item.loot_bonus = (item.loot_bonus || 0) + affix.loot_bonus;
  }
};

const ItemGenerator = {
  getCavernsMobItem(ItemClass, mob_level) {
    if (isNaN(mob_level) || mob_level < 1) throw new Error(`invalid mob_level: ${mob_level}`);
    const minQuality = mob_level / 200;
    const maxQuality = Math.min(1, 0.1 + mob_level / 100);
    return ItemGenerator.getRandomItem(ItemClass, minQuality, maxQuality);
  },

  getPrayerItem(prayerResult) {
    let itemQuality = prayerResult.itemQuality;
    const { prefixQuality, suffixQuality } = prayerResult;
    assert.equal(typeof itemQuality, 'number', `invalid itemQuality ${itemQuality}`);
    if (itemQuality < 0) {
      itemQuality = 0;
    }
    if (itemQuality > 1) {
      itemQuality = 1;
    }

    if (!prayerResult.godTag) {
      // backwards-compatibility with legacy variable name
      prayerResult.godTag = prayerResult.targetGod;
    }
    assert.ok(
      ['order', 'balance', 'chaos'].includes(prayerResult.godTag),
      'invalid prayerResult.godTag'
    );

    let ItemClass = ALL_ITEM_CLASSES.find((ItemClass) => {
      return (
        ItemClass(1).slot === prayerResult.itemSlot && ItemClass(1).type === prayerResult.itemType
      );
    });
    if (!ItemClass) {
      ItemClass = ALL_ITEM_CLASSES[Math.floor(Math.random() * ALL_ITEM_CLASSES.length)];
    }

    const _item = ItemClass(Math.min(1, itemQuality));

    if (_item.slot !== 'item_container') {
      // potentially add an item prefix
      const chance_for_prefix = prefixQuality - 0.1 + Math.random() * 0.3;
      if (Math.random() < chance_for_prefix) {
        let prefixCandidates = PREFIXES.slice();

        if (_item.slot === 'weapon' || _item.type === 'bow') {
          prefixCandidates = prefixCandidates.concat(WEAPON_PREFIXES);
        } else if (_item.slot === 'boots' || _item.slot === 'torsoe' || _item.slot === 'helmet') {
          prefixCandidates = prefixCandidates.concat(ARMOR_PREFIXES);
        }

        let finalCandidates;
        for (let margin = 0.15; margin <= 1; margin += 0.05) {
          finalCandidates = prefixCandidates.filter((pc) => {
            return pc.quality >= prefixQuality - margin && pc.quality <= prefixQuality + margin;
          });
          if (finalCandidates.length >= 3) {
            break;
          }
        }
        assert.ok(
          Array.isArray(finalCandidates) && finalCandidates.length,
          'failed to get prefixCandidates'
        );

        const prefix = finalCandidates[Math.floor(Math.random() * finalCandidates.length)];
        if (prefix) {
          _item.prefix = prefix.tag;
          _item.prefixQuality = prefix.quality;
          addAffixMods(_item, prefix);
        }
      }

      // potentially add an item suffix
      const chance_for_suffix = suffixQuality - 0.1 + Math.random() * 0.3;
      if (Math.random() < chance_for_suffix) {
        let suffixCandidates = SUFFIXES.slice();

        if (_item.slot === 'weapon' || _item.type === 'bow') {
          suffixCandidates = suffixCandidates.concat(WEAPON_SUFFIXES);
        }

        suffixCandidates = suffixCandidates.filter((s) => {
          switch (prayerResult.godTag) {
            case 'chaos':
              return CHAOS_SUFFIX_TAGS.includes(s.tag);
            case 'balance':
              return BALANCE_SUFFIX_TAGS.includes(s.tag);
            case 'order':
              return ORDER_SUFFIX_TAGS.includes(s.tag);
            default:
              return true;
          }
        });

        let finalCandidates;
        for (let margin = 0.15; margin <= 1; margin += 0.05) {
          finalCandidates = suffixCandidates.filter((sc) => {
            return sc.quality >= suffixQuality - margin && sc.quality <= suffixQuality + margin;
          });
          if (finalCandidates.length >= 3) {
            break;
          }
        }

        const suffix = finalCandidates[Math.floor(Math.random() * finalCandidates.length)];
        if (suffix) {
          _item.suffix = suffix.tag;
          _item.suffixQuality = suffix.quality;
          addAffixMods(_item, suffix);
        }
      }
    }

    _item.uid = uuidv4();
    _item.tint = Math.random() * 0xffffff;

    lastItem = _item;

    return _item;
  },

  getRandomItem(ItemClass, minQuality, maxQuality, newHeroItem = false) {
    let _item;
    const quality = Math.min(1, minQuality + Math.random() * (maxQuality - minQuality));

    if (ItemClass) {
      _item = ItemClass(quality);
    } else {
      const class_candidates = ALL_ITEM_CLASSES.filter((IC) => {
        const dummy = IC(1.0);
        return dummy.slot !== lastItem.slot && dummy.type !== lastItem.type;
      });

      ItemClass = class_candidates[Math.floor(Math.random() * class_candidates.length)];
      _item = ItemClass(quality);
    }

    if (_item.slot !== 'item_container') {
      // chance to add a prefix
      if (Math.random() < 0.1) {
        let prefixCandidates = PREFIXES.slice();
        if (newHeroItem) {
          prefixCandidates = prefixCandidates.filter((p) => !['cursed', 'unlucky'].includes(p.tag));
        }

        if (_item.slot === 'weapon' || _item.type === 'bow') {
          prefixCandidates = prefixCandidates.concat(WEAPON_PREFIXES);
        } else if (['boots', 'torsoe', 'helmet'].includes(_item.slot)) {
          prefixCandidates = prefixCandidates.concat(ARMOR_PREFIXES);
        }

        const prefix = prefixCandidates[Math.floor(Math.random() * prefixCandidates.length)];
        _item.prefix = prefix.tag;
        _item.prefixQuality = prefix.quality;
        addAffixMods(_item, prefix);
      }

      // chance to add a suffix (rings always get suffixes)
      if (Math.random() < 0.1 || _item.type === 'ring') {
        let suffixCandidates = SUFFIXES.slice();

        if (newHeroItem) {
          suffixCandidates = suffixCandidates.filter((s) => s.tag !== 'doom');
        }

        if (_item.slot === 'weapon' || _item.type === 'bow') {
          suffixCandidates = suffixCandidates.concat(WEAPON_SUFFIXES);
        }

        const suffix = suffixCandidates[Math.floor(Math.random() * suffixCandidates.length)];
        _item.suffix = suffix.tag;
        _item.suffixQuality = suffix.quality;
        addAffixMods(_item, suffix);
      }
    }

    _item.uid = uuidv4();
    _item.tint = Math.random() * 0xffffff;

    lastItem = _item;

    return _item;
  },

  getSpecificItem({
    ItemClass,
    minQuality,
    maxQuality,
    prefix_chance, // if num, 0~1; if string, use as prefix key
    suffix_chance, // if num, 0~1; if string, use as prefix key
    tint,
  }) {
    let _item;
    const quality = Math.min(1, minQuality + Math.random() * (maxQuality - minQuality));

    if (ItemClass) {
      _item = ItemClass(quality);
    } else {
      const class_candidates = ALL_ITEM_CLASSES.filter((IC) => {
        const dummy = IC(1.0);
        return dummy.slot !== lastItem.slot && dummy.type !== lastItem.type;
      });

      ItemClass = class_candidates[Math.floor(Math.random() * class_candidates.length)];
      _item = ItemClass(quality);
    }

    if (_item.slot !== 'item_container') {
      // chance to add a prefix
      let prefix;
      if (typeof prefix_chance === 'string') {
        prefix = []
          .concat(PREFIXES, ARMOR_PREFIXES, WEAPON_PREFIXES)
          .find(({ tag }) => tag === prefix_chance);
      } else if (Math.random() < prefix_chance) {
        let prefixCandidates = PREFIXES.slice();
        if (_item.slot === 'weapon' || _item.type === 'bow') {
          prefixCandidates = prefixCandidates.concat(WEAPON_PREFIXES);
        } else if (['boots', 'torsoe', 'helmet'].includes(_item.slot)) {
          prefixCandidates = prefixCandidates.concat(ARMOR_PREFIXES);
        }

        prefix = prefixCandidates[Math.floor(Math.random() * prefixCandidates.length)];
      }
      if (prefix) {
        _item.prefix = prefix.tag;
        _item.prefixQuality = prefix.quality;
        addAffixMods(_item, prefix);
        _item.prefix = prefix.tag;
      }

      // chance to add a suffix (rings always get suffixes)
      let suffix;
      if (typeof suffix_chance === 'string') {
        suffix = [].concat(SUFFIXES, WEAPON_SUFFIXES).find(({ tag }) => tag === suffix_chance);
      } else if (Math.random() < 0.1 || _item.type === 'ring') {
        let suffixCandidates = SUFFIXES.slice();
        if (_item.slot === 'weapon' || _item.type === 'bow') {
          suffixCandidates = suffixCandidates.concat(WEAPON_SUFFIXES);
        }
        suffix = suffixCandidates[Math.floor(Math.random() * suffixCandidates.length)];
      }
      if (suffix) {
        _item.suffix = suffix.tag;
        _item.suffixQuality = suffix.quality;
        addAffixMods(_item, suffix);
      }
    }

    _item.uid = uuidv4();
    _item.tint = tint || Math.random() * 0xffffff;

    return _item;
  },
};
module.exports = ItemGenerator;
